module.exports = __webpack_public_path__ + "static/tuebingen-ref-img-522c85601aa3c0e002e93336184ae64a.jpg";